import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { RentalObjectCategory } from '../../../rent/model/const/enums';
import { PieChartComponentBase } from '../base/pie-chart.base';

@Component({
    selector: 'app-vacancies',
    templateUrl: './vacancies.component.html',
    styleUrls: ['./vacancies.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VacanciesComponent extends PieChartComponentBase implements OnChanges, OnInit {
  constructor() {
    super();
  }

  @Input() data: any;

  categoryIcon: any;
  share: number = 0;
  total: number = 0;
  vacant: number = 0;
  rented: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      this.categoryIcon = {
        'house-user': this.data.category === RentalObjectCategory.Dwelling,
        'house-blank': this.data.category === RentalObjectCategory.Other,
        car: this.data.category === RentalObjectCategory.Parking,
        store: this.data.category === RentalObjectCategory.Premises,
      };

      var currentValue = changes['data'].currentValue;
      this.total = currentValue.totalRentalObjectCount;
      this.vacant = currentValue.vacantRentalObjectCount;
      this.rented = currentValue.getRentedCount();
      if (this.vacant) {
        this.share = Math.round((this.vacant / this.total) * 100);
      }

      this._updateView(!changes['data'].firstChange);
    }
  }

  private _updateView(updatePie: boolean) {
    let values = [];
    if (this.total == 0) {
      values = [0, 1];
    } else {
      values = this.rented == 0 ? [1, 0] : [this.rented, this.vacant];
    }

    if (updatePie) {
      this.updatePie(values);
    }
  }

  ngOnInit() {
    this.colors = ['#2BA498', '#F4A909'];
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this._updateView(true);
  }
}
